import { Dispatch } from 'redux';

import {
  JobFunctions,
  fetchJobFunctions as apiFetchJobFunctions,
} from 'api/orgs';

import { setError } from './error';

// Types

export type MainStoreJobFunctionsState = JobFunctions | null | undefined;

export type MainStoreJobFunctionsAction = {
  type: 'JOB_FUNCTIONS_SET';
  jobFunctions: JobFunctions | null | undefined;
};

// Reducer

export function jobFunctionsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreJobFunctionsState = null,
  action: MainStoreJobFunctionsAction
) {
  switch (action.type) {
    case 'JOB_FUNCTIONS_SET': {
      return action.jobFunctions;
    }

    default:
      return state;
  }
}

// Actions

export const fetchJobFunctions =
  () =>
  (
    dispatch: Dispatch<MainStoreJobFunctionsAction>,
    getState: () => { jobFunctions: MainStoreJobFunctionsState }
  ) => {
    if (getState().jobFunctions) {
      return;
    }

    apiFetchJobFunctions()
      .then((jobFunctions) => {
        dispatch({
          type: 'JOB_FUNCTIONS_SET',
          jobFunctions,
        });
      })
      .catch(setError);
  };
